import { RuleTypeEnum } from '../models/rule-type';

export const RuleTypeLabelPipe = ruleType => {
    switch (ruleType) {
        case RuleTypeEnum.BASIC_ID_NEW_PLAYER:
            return 'New Player Id';
        case RuleTypeEnum.DEPOSIT_REQUIRES_PEP_AND_SANCTION:
            return 'PEP/Sanction Deposit';
        case RuleTypeEnum.DEPOSIT_LIMIT_WITHOUT_BASIC_INFO:
            return 'Deposit Limit (Basic Info)';
        case RuleTypeEnum.DEPOSIT_LIMIT_WITHIN_GRACEPERIOD_WITHOUT_ALL_CHECKS:
            return 'Deposit Limit (Checks)';
        case RuleTypeEnum.HIGH_RISK_DEPOSIT_WITHOUT_ALL_CHECKS:
            return 'No Check Deposit';
        case RuleTypeEnum.TOO_MANY_DEPOSITS_IN_SHORT_PERIOD:
            return 'Too Many Deposits';
        case RuleTypeEnum.CONTINUOUS_ACTIVITY_IN_PERIOD:
            return 'Continuous Activity';
        case RuleTypeEnum.CHASING_LOSSES:
            return 'Chasing Losses';
        case RuleTypeEnum.NEGATIVE_INTERACTION:
            return 'Negative Interaction';
        case RuleTypeEnum.ASK_FOR_OFFERS_X_TIMES_IN_PERIOD:
            return 'Offer Requests';
        case RuleTypeEnum.TOTAL_DEPOSITS_PLAYER_LIFETIME:
            return 'Total Deposits';
        case RuleTypeEnum.TOTAL_WITHDRAWALS_PLAYER_LIFETIME:
            return 'Total Withdrawals';
        case RuleTypeEnum.EXPIRED_DOCUMENTATION:
            return 'Expired Documentation';
        default:
            return ruleType;
    }
};
